import { render, staticRenderFns } from "./Services-CustomerResponsibilty.vue?vue&type=template&id=7c434499"
import script from "./Services-CustomerResponsibilty.vue?vue&type=script&lang=js"
export * from "./Services-CustomerResponsibilty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports